import Title from "antd/es/typography/Title";
import { Slider, Segmented, InputNumber } from "antd";
import { useEffect, useMemo, useState } from "react";
import { Header } from "./Header";
import { SimilarityMap } from "./SimilarityMap";
import { SimilarityTab } from "./SimilarityTab";
import React from "react";
import { BrowserRouter, Link, Route, Routes, useNavigate } from "react-router-dom";
import { FindWord } from "./FindWord";
import { Articles } from "./Articles";
import { AIAssistant } from "./AIAssistant";
import { v4 as uuidv4 } from 'uuid';
import { useMediaQuery } from "@uidotdev/usehooks";


export const App = () => {

  const navigate = useNavigate();
  const [showResult, setShowResult] = useState(false);
  const generateThreadId = useMemo(() => uuidv4(), []);
  const [response, setResponse] = useState<{ type: string, text: string }[]>([]);
  const isMobile = useMediaQuery('(max-width: 600px)');
  return (
    <>
      {!isMobile && <Header>
        <Title level={5} onClick={() => navigate("/yasi")} style={{ cursor: "pointer" }}>Find a Word With AI</Title>
        <Title level={5} onClick={() => navigate("/yasi/find-word")} style={{ cursor: "pointer" }}>Find a Word</Title>
        <Title level={5} onClick={() => navigate("/yasi/articles")} style={{ cursor: "pointer" }}>Articles</Title>
        <Title level={5} onClick={() => navigate("/yasi/similarity")} style={{ cursor: "pointer" }}>Similarity Map</Title>
      </Header>}
      <div style={{ paddingTop: 80, paddingLeft: 16 }}>

        <Routes>
          <Route path="/yasi" element={<AIAssistant threadId={generateThreadId} response={response} setResponse={setResponse} />} />
          <Route path="/yasi/find-word" element={<FindWord showResult={showResult} setShowResult={setShowResult} />} />
          <Route path="/yasi/articles" element={<Articles />} />
          <Route path="/yasi/similarity" element={<SimilarityTab />} />
        </Routes>

      </div>
    </>
  );
}

export default App;

const a = [
  {
    name: "18-1-1",
    id: '18-1-1',
    similarities: [
      { id: '18-1-2', similarity: 0.3 },
      { id: '18-1-3', similarity: 0.6 },
      { id: '18-1-4', similarity: 0.9 },
    ],
  },
  {
    name: "18-1-2",
    id: '18-1-2',
    similarities: [
      { id: '18-1-1', similarity: 0.3 },
      { id: '18-1-3', similarity: 0.6 },
      { id: '18-1-4', similarity: 0.9 },
    ],
  },
  {
    name: "18-1-3",
    id: '18-1-3',
    similarities: [
      { id: '18-1-1', similarity: 0.6 },
      { id: '18-1-2', similarity: 0.6 },
      { id: '18-1-4', similarity: 0.3 },
    ],
  },
  {
    name: "18-1-4",
    id: '18-1-4',
    similarities: [
      { id: '18-1-1', similarity: 0.9 },
      { id: '18-1-2', similarity: 0.9 },
      { id: '18-1-3', similarity: 0.3 },
    ],
  },
];